
import Vue from 'vue'
import Router from 'vue-router'
import { year, location } from './pre'
import utils from '@/utils'
import store from '@/store'

const ConHome = () => import(/* webpackChunkName: "home" */ '@/views/con-home')
const ConSpeakers = () => import(/* webpackChunkName: "speakers" */ '@/views/con-speakers')
const ConSpeaker = () => import(/* webpackChunkName: "speaker" */ '@/views/con-speaker')
const ConTracks = () => import(/* webpackChunkName: "tracks" */ '@/views/con-tracks')
const ConTrack = () => import(/* webpackChunkName: "track" */ '@/views/con-track')
const ConSchedule = () => import(/* webpackChunkName: "schedule" */ '@/views/con-schedule')
// const ConArticles = () => import(/* webpackChunkName: "articles" */ '@/views/con-articles')
const ConAbout = () => import(/* webpackChunkName: "about" */ '@/views/con-about')
const ConApply = () => import(/* webpackChunkName: "apply" */ '@/views/con-apply')
// const ConStar = () => import(/* webpackChunkName: "star" */ '@/views/con-star')
const ConTopic = () => import(/* webpackChunkName: "topic" */ '@/views/con-topic')
// const ConVolunteer = () => import(/* webpackChunkName: "volunteer" */ '@/views/con-volunteer')
const ConNotFound = () => import(/* webpackChunkName: "404" */ '@/views/con-not-found')
const ConPresentation = () => import(/* webpackChunkName: "Presentation" */ '@/views/con-presentation')
const ConTrainings = () => import(/* webpackChunkName: "trainings" */ '@/views/con-trainings')
const ConTraining = () => import(/* webpackChunkName: "training" */ '@/views/con-training')
// const ConVideos = () => import(/* webpackChunkName: "videos" */ '@/views/con-videos')
const convinceYourBoss = () => import(/* webpackChunkName: "convinboss" */ '@/views/con-convinboss')
const Freehot = () => import(/* webpackChunkName: "freehot" */ '@/views/con-freehot')
Vue.use(Router)

const router = new Router({
  base: `/${year}/${location}`,
  mode: 'history',
  routes: [
    {
      name: 'home',
      path: '/',
      component: ConHome
    },
    // 所有讲师
    {
      name: 'speaker',
      path: '/speaker',
      component: ConSpeakers
    },
    // 查看单个讲师信息
    {
      path: '/speaker/:id',
      component: ConSpeaker,
      props: true
      // alias: '/lecture/:id'
    },
    // 主题演讲嘉宾介绍页
    {
      path: '/presentation/:id',
      component: ConPresentation,
      props: true
    },
    // 所有演讲专题
    {
      path: '/track',
      component: ConTracks
    },
    // 单个演讲专题
    {
      path: '/track/:id',
      component: ConTrack,
      props: true
    },
    // 日程
    {
      path: '/schedule',
      component: ConSchedule
    },
    // // 技术专栏
    // {
    //   path: '/article',
    //   component: ConArticles
    // },
    // 参会须知 (支付相关等信息)
    {
      path: '/about',
      component: ConAbout
    },
    // 购票页面
    {
      path: '/apply',
      component: ConApply
    },
    // // 全部讲师 (gtlc中暂且还没使用)
    // {
    //   path: '/star',
    //   component: ConStar
    // },
    // 议题提交
    {
      path: '/topic',
      component: ConTopic
    },
    // // 志愿者服务
    // {
    //   path: '/volunteer',
    //   component: ConVolunteer
    // },
    {
      path: '/training/:id',
      component: ConTraining,
      props: true
    },
    {
      path: '/training/',
      component: ConTrainings
    },
    // {
    //   path: '/videos',
    //   component: ConVideos
    // },
    // 免费领取Hot
    {
      path: '/freehot',
      component: Freehot
    },
    // 重定向
    {
      path: '/speakers', redirect: 'speaker'
    },
    {
      path: '/lecture/:id', redirect: '/speaker/:id'
    },
    {
      path: '/tracks', redirect: 'track'
    },
    {
      path: '/convince-your-boss',
      component: convinceYourBoss
    },
    {
      path: '/producer', redirect: 'track'
    },
    {
      path: '/tech', redirect: 'article'
    },
    {
      path: '*',
      component: ConNotFound
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      // savedPosition is only available for popstate navigations.
      return savedPosition
    } else {
      const position = {}
      // new navigation.
      // scroll to anchor by returning the selector
      if (to.hash) {
        position.selector = to.hash
      }
      // check if any matched route config has meta that requires scrolling to top
      if (to.matched.some(m => m.meta.scrollToTop)) {
        // cords will be used if no selector is provided,
        // or if the selector didn't match any element.
        position.x = 0
        position.y = 0
      }

      if (!Object.keys(position).length) {
        position.x = 0
        position.y = 0
      }

      // if the returned position is falsy or an empty object,
      // will retain current scroll position.
      return position
    }
  }
})

router.beforeEach((to, from, next) => {
  next()
  // 初始化微信配置
  // utils.initWxConfig().then(() => {
  //   next()
  // }).catch(() => {
  //   next()
  // })
})

// 设置谷歌统计
utils.GA('create', store.state.comConfig.GAUA, 'auto')

router.afterEach((to, from) => {
  utils.weixinshare()
  utils.GA('set', 'page', to.fullPath)
  utils.GA('send', 'pageview')
})

export { year, location }
export default router
